import type { Dayjs } from "dayjs";
import dayjs from "../dayjsConfig.js";
import {
	getStringMonthNumber,
	getTotalDaysOfMonth,
} from "../sharedFunctions/sharedFunctions.js";
import type { Statistics } from "../types/index.js";

export const currentYear = dayjs.utc().format("YYYY");
export const previousYear = dayjs.utc().subtract(1, "year").format("YYYY");
export const currentMonth = dayjs.utc().format("M");
export const previousMonth = dayjs.utc().subtract(1, "month").format("M");
export const previousDay = dayjs.utc().subtract(1, "day").format("D");
export const appStartYear = 2022;
export const arrayOfYearsForSelectFilter = creatArrayOfYears();
export const DEFAULT_CLIENT = {
	name: "",
	surname: "",
	bankAccount: "",
	instagramLink: "",
	suspended: false,
	svadba: {
		login: "",
		password: "",
	},
	dating: {
		login: "",
		password: "",
	},
	image: "",
};

export class DEFAULT_PENALTY {
	dateTimeId: string;
	amount: number;
	description: string;
	translator: string;

	constructor(translatorId: string, dateTimeId: string) {
		this.dateTimeId = dateTimeId;
		this.amount = 0;
		this.description = "";
		this.translator = translatorId;
	}
}

export class DEFAULT_MONTH_CHART {
	year: string;
	month: string;
	days: number[];
	values: number[];

	constructor(year: string, month: number) {
		this.year = year;
		this.month = getStringMonthNumber(month);
		this.days = getTotalDaysOfMonth(year, month);
		this.values = [];
	}
}

type Entity = {
	_id: string;
};

export class EMPTY_BALANCE_DAY {
	dateTimeId: string;
	client: Entity;
	translator: Entity;
	statistics: Statistics;
	/**
	 * Nothing has been earned on a day that does not exist yet. Stated rather
	 * than left out so the form can read `total` off a saved day and a fresh one
	 * alike.
	 */
	total = 0;

	constructor(translatorId: string, clientId: string, dateTimeId: string) {
		this.dateTimeId = dateTimeId;
		this.client = { _id: clientId };
		this.translator = { _id: translatorId };
		const emptyStatistics: Statistics = {
			chats: 0,
			letters: 0,
			dating: 0,
			virtualGiftsSvadba: 0,
			virtualGiftsDating: 0,
			photoAttachments: 0,
			phoneCalls: 0,
			penalties: 0,
			comments: "",
			voiceMessages: 0,
			bonuses: 0,
			photoAttachmentsDating: 0,
			voiceMessagesDating: 0,
			lettersDating: 0,
			// New: dating phone calls statistics
			phoneCallsDating: 0,
		};

		this.statistics = emptyStatistics;
	}
}

export type ErrorState = {
	text?: string;
	status: boolean;
};

export const DEFAULT_ERROR: ErrorState = {
	status: false,
};

export const DEFAULT_TRANSLATOR = {
	name: "",
	surname: "",
	suspended: {
		status: false,
		time: null,
	},
	email: null,
};

export const SUNRISE_AGENCY_ID = "62470d5dffe20600169edac1";

function creatArrayOfYears() {
	const arrayWithYears = [];
	const lengthOfArrayWithYears = Number(currentYear) - appStartYear;
	for (let i = 0; i < lengthOfArrayWithYears + 1; i++) {
		arrayWithYears.unshift(String(appStartYear + i));
	}
	return arrayWithYears;
}

export const FINANCE_SENDERS = {
	anton: "Anton",
	agency: "Agency",
	oleksandr: "Oleksandr",
};

export const FINANCE_COMMENTS = {
	salary: "salary",
	paymentToScout: "Payment to scout",
	paymentToBot: "Payment to bot",
	paymentToTranslator: "Payment to translator",
};

export const DEFAULT_STATEMENT: {
	// The receivers dropdown puts the whole option here, not just a name.
	receiver: string | { id: string; label: string };
	amount: number;
	sender: string;
	comment: string;
	date: Dayjs;
} = {
	receiver: "",
	amount: 0,
	sender: FINANCE_SENDERS.agency,
	comment: FINANCE_COMMENTS.salary,
	date: dayjs.utc(),
};

export const BOT_LIST = [
	{ id: "Chat4me7210Sunrise", label: "Chat4me" },
	{ id: "Sender7210Sunrise", label: "Sender" },
];

export const TRANSLATORS_SALARY_PERCENT = 0.45;
export const PAYONEER_COMISSION = 0.968;

// Centralized rating thresholds (ascending). Values are daily/monthly averages.
// Clients: five thresholds map to 1..5 stars
// Translators: five thresholds map to 1..5 stars
export const RATING_THRESHOLDS = {
	clients: [10, 20, 40, 60, 80],
	translators: [10, 20, 30, 40, 50],
} as const;
